import { render, staticRenderFns } from "./task_form.vue?vue&type=template&id=200924d1&scoped=true&"
import script from "./task_form.vue?vue&type=script&lang=js&"
export * from "./task_form.vue?vue&type=script&lang=js&"
import style0 from "./task_form.vue?vue&type=style&index=0&id=200924d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200924d1",
  null
  
)

export default component.exports